<template>
  <div class="p-property-list">
    <div
      v-for="(item, index) in value"
      :key="index"
      class="p-property-list__item"
    >
      <div
        class="p-property-list__name el-text el-text--body-24 el-text--ellipsis"
        :data-test-id="`property-list.name-${index}`"
      >
        {{ item.name }}
      </div>
      <div
        class="p-property-list__value el-text--white-space-pre-line"
        :data-test-id="`property-list.value-${index}`"
      >
        <property-value
          :value="item.value"
          :transform="item.transform"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PropertyValue from '@/app/components/PropertyValue';

export default {
  name: 'PropertyList',
  components: {
    PropertyValue
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@uikit/ui-kit/themes/acronis/src/common/variables';

.p-property-list {

  &__item {
    display: flex;
    border-bottom: $av-border-sm $av-brand-accent;

    &:last-child {
      border-bottom: none;
    }
  }

  &__name,
  &__value {
    width: 50%;
    padding: 12px 24px;
  }
}
</style>
